import {BannerNudgeCardPartial, type BannerNudgeCardPartialProps} from '../banner-nudge-card/BannerNudgeCardPartial'
import {Stackable} from './Stackable'

export interface NudgeCardStackPartialProps {
  cards: BannerNudgeCardPartialProps[]
}

// Thin partial wrapper that bridges the JSON-props world (Ruby
// `render_react_partial`) to the React-children world (`Stackable`). The
// underlying `Stackable` stays a generic stacker that takes any children; this
// wrapper just maps `cards` into `BannerNudgeCardPartial` elements.
export function NudgeCardStackPartial({cards}: NudgeCardStackPartialProps) {
  if (!cards || cards.length === 0) {
    return null
  }

  return (
    <Stackable>
      {cards.map(card => (
        <BannerNudgeCardPartial key={card.testSelector} {...card} />
      ))}
    </Stackable>
  )
}
